<template>
    <span class="inline-flex rounded-md shadow-sm">
        <button :type="type"
                class="inline-flex justify-center items-center w-full px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white focus:outline-none transition ease-in-out duration-150"
                :class="classes"
                v-if="! href"
        >
            <slot></slot>
        </button>

        <a :href="href"
           class="inline-flex justify-center items-center w-full px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white focus:outline-none transition ease-in-out duration-150"
           :class="classes"
           v-else
        >
            <slot></slot>
        </a>
    </span>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'button'
            },

            colour: {
                type: String,
                default: 'primary'
            },

            disabled: {
                type: Boolean,
                default: false,
            },

            href: {
                type: String,
            }
        },

        computed: {
            classes() {
                return {
                    'bg-primary-600 hover:bg-primary-500 focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700': this.colour === 'primary' && ! this.disabled,
                    'bg-red-600 hover:bg-red-500 focus:border-red-700 focus:shadow-outline-red active:bg-red-700 text-white': this.colour === 'red' && ! this.disabled,
                    'bg-white border-gray-300 text-gray-700 hover:text-gray-500 focus:border-blue-300 focus:shadow-outline-blue': this.colour === 'white' && ! this.disabled,
                    'bg-black border-black text-white hover:bg-gray-800 focus:border-blue-300 focus:shadow-outline-blue': this.colour === 'black' && ! this.disabled,
                    'bg-gray-50 border-gray-50 text-gray-200 hover:text-gray-200 focus:border-gray-200 focus:shadow-none': this.disabled
                }
            }
        }
    }
</script>
